// extracted by mini-css-extract-plugin
export var hidden = "_51-1";
export var leftPanel = "_51-2";
export var readonlyInspector = "_51-3";
export var rightPanel = "_51-0";